<div class="button-container">
  <button mat-icon-button mat-dialog-close class="close-button" aria-label="Close">
    <span class="material-symbols-outlined"> cancel </span>
  </button>
</div>

<span class="title" mat-dialog-title>Error on Registration</span>
<div mat-dialog-content>
  <p class="body">{{ errorMessage }}</p>
</div>
<div class="button-container" mat-dialog-actions>
  <button class="back-button" mat-button mat-dialog-close>Back</button>
</div>
